'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _combineStyles = require('../../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var myMessage = arguments[1];
  var avatar = arguments[2];
  var compact = arguments[3];
  var collapsed = arguments[4];
  var iconMenu = arguments[5];
  var overrideStyle = arguments[6];

  var style = _styles2.default.message;

  if (myMessage) {
    style = (0, _combineStyles2.default)((0, _combineStyles2.default)(_styles2.default.message, _styles2.default.myMessage), { backgroundColor: color, borderRightColor: color });
  }

  if (avatar) {
    style = (0, _combineStyles2.default)(style, _styles2.default.avatar);
  }

  if (myMessage && avatar) {
    style = (0, _combineStyles2.default)(style, { marginLeft: '0', marginRight: '48px' });
  }

  if (compact) {
    style = (0, _combineStyles2.default)(style, _styles2.default.compact);
  }

  if (compact && collapsed) {
    style = (0, _combineStyles2.default)(style, { display: 'flex' });
  }

  if (collapsed && iconMenu) {
    style = (0, _combineStyles2.default)(style, { padding: '13px 48px 13px 13px' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var body = function body(myMessage, fontSize, collapsed, overrideStyle) {
  var style = _styles2.default.body;

  if (myMessage) {
    style = (0, _combineStyles2.default)(style, { color: _colors2.default.white });
  }

  if (fontSize === 'medium') {
    style = (0, _combineStyles2.default)(style, { fontSize: '18px', lineHeight: '20px' });
  }

  if (fontSize === 'large') {
    style = (0, _combineStyles2.default)(style, { fontSize: '22px', lineHeight: '24px' });
  }

  if (collapsed) {
    style = (0, _combineStyles2.default)(style, { display: 'initial' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var giphy = function giphy(lightbox) {
  var style = _styles2.default.giphy;

  if (lightbox) {
    style = (0, _combineStyles2.default)(style, { cursor: 'pointer' });
  }

  return style;
};

exports.default = {
  root: root,
  body: body,
  giphy: giphy
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/giphy-message/get-styles.js
// module id = 808
// module chunks = 0